<template>
  <v-dialog :model-value="isRevealed" persistent>
    <v-card :title="revealData?.title">
      <v-card-text v-for="(item, index) in messages" :key="index" v-bind="item.itemProps">
        {{ item.message }}
      </v-card-text>

      <v-card-actions>
        <v-btn variant="tonal" @click="cancel">
          {{ revealData?.noBtnText ?? t('messages.no') }}
        </v-btn>
        <v-btn color="primary" variant="flat" @click="confirm">
          {{ revealData?.yesBtnText ?? t('messages.yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { type Data, useConfirmationDialog } from './ConfirmationDialog.context';

const { t } = useI18n();

const { cancel, confirm, isRevealed, onReveal } = useConfirmationDialog();

const revealData = ref<Data>();

onReveal((data: Data) => {
  revealData.value = data;
});

const messages = computed(() => {
  if (!revealData.value?.message) {
    return [];
  }

  if (typeof revealData.value.message === 'string') {
    return [{ message: revealData.value.message }];
  }

  return revealData.value.message.map((item) => {
    if (typeof item === 'string') {
      return { message: item };
    }

    return item;
  });
});
</script>
